import React from "react";
import StatCard from "@/components/atomics/stat-card";
import { ViewState, OwnerState, OwnerStats } from "@/types/owner-edit";
import { ownerEditUtils } from "@/utils/owner-edit";

interface OwnerStatsProps {
  ownerData: OwnerState;
  viewState: ViewState;
  stats: OwnerStats;
  onUpdateStats: (index: number) => void;
}

const OwnerStatsComponent: React.FC<OwnerStatsProps> = ({
  ownerData,
  viewState,
  stats,
  onUpdateStats,
}) => {
  const statsConfig = [
    {
      key: "collections",
      title: "Created",
      subtitle: "COLLECTIONS",
      value: stats.created_collections,
      index: 0,
    },
    {
      key: "nfts",
      title: "Minted",
      subtitle: "NFTs",
      value: stats.minted_nfts,
      index: 1,
    },
    {
      key: "earned",
      title: "Earned",
      subtitle: "TON",
      value: stats.earned,
      index: 2,
    },
  ];

  return (
    <div className="flex justify-center gap-[10px] pb-[30px]">
      {statsConfig.map(stat => (
        <StatCard
          key={stat.key}
          title={stat.title}
          subtitle={stat.subtitle}
          value={stat.value}
          isVisible={ownerData.stats[stat.index]?.isVisible ?? true}
          isOwnerView={viewState.isOwnerView}
          isEditView={viewState.isEditView}
          onChange={() => onUpdateStats(stat.index)}
        />
      ))}
    </div>
  );
};

export default OwnerStatsComponent;
